import { render, staticRenderFns } from "./InvertidosNoIniciados.vue?vue&type=template&id=4e2939aa&scoped=true"
import script from "./InvertidosNoIniciados.vue?vue&type=script&lang=js"
export * from "./InvertidosNoIniciados.vue?vue&type=script&lang=js"
import style0 from "./InvertidosNoIniciados.vue?vue&type=style&index=0&id=4e2939aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2939aa",
  null
  
)

export default component.exports